export class TicketDocumentResult {
    public id: number = 0;
    public documentFileName: string = '';
}
